import { defaultString, defaultSettings } from "../defaultValues";

import {
  isValidObject,
  betCheck,
  numberOfBetsCheck,
  onWinResetCheck,
  onWinPercentCheck,
  onLossResetCheck,
  onLossPercentCheck,
  stopOnProfitCheck,
  stopOnLossCheck,
  musicCheck,
  soundCheck,
  volumeCheck,
} from "../checkerFunctions";


export const objToStringSettings = (obj, min, max) => {
  if (!isValidObject(obj)) return defaultString;

  const { bet, auto, audio } = obj;
  const {
    numberOfBets,
    onWinReset,
    onWinPercent,
    onLossReset,
    onLossPercent,
    stopOnProfit,
    stopOnLoss,
  } = auto;
  const betCHECKED = betCheck(bet, min, max, defaultSettings.bet);
  const numberOfBetsCHECKED = numberOfBetsCheck(
    numberOfBets,
    defaultSettings.auto.numberOfBets
  );
  const onWinResetCHECKED = onWinResetCheck(
    onWinReset,
    defaultSettings.auto.onWinReset
  );
  const onWinPercentCHECKED = onWinPercentCheck(
    onWinPercent,
    defaultSettings.auto.onWinPercent
  );
  const onLossResetCHECKED = onLossResetCheck(
    onLossReset,
    defaultSettings.auto.onLossReset
  );
  const onLossPercentCHECKED = onLossPercentCheck(
    onLossPercent,
    defaultSettings.auto.onLossPercent
  );
  const stopOnProfitCHECKED = stopOnProfitCheck(
    stopOnProfit,
    defaultSettings.auto.stopOnProfit
  );
  const stopOnLossCHECKED = stopOnLossCheck(
    stopOnLoss,
    defaultSettings.auto.stopOnLoss
  );

  const { music, sound, volume } = audio;
  const musicCHECKED = musicCheck(music, defaultSettings.audio.music);
  const soundCHECKED = soundCheck(sound, defaultSettings.audio.sound);
  const volumeCHECKED = volumeCheck(volume, defaultSettings.audio.volume);

  return `${betCHECKED};${numberOfBetsCHECKED};${onWinResetCHECKED};${onWinPercentCHECKED};${onLossResetCHECKED};${onLossPercentCHECKED};${stopOnProfitCHECKED};${stopOnLossCHECKED};${musicCHECKED};${soundCHECKED};${volumeCHECKED}`;
};
